// components/viewMoreArticles.js
import React from "react";
import { Link } from "react-router-dom";

export default function ViewMoreArticlesFunc({ viewMoreArticles = [], path = "" }) {
  if (!viewMoreArticles.length) return null;

  return (
    <div className="w-full bg-gray-200 py-8 px-16">
      <h2 className="text-xl">Fler nyheter</h2>
      <ul className="mt-4">
        {viewMoreArticles.map((article) => (
          <li className="list-none mt-4 pb-4 border-b border-gray-200" key={article.link}>
            <Link className="flex items-center" to={`${path}/nyheter/${article.link}`}>
              <div className="ml-0">
                <h4 className="font-semibold">{article.name}</h4>
                {article.date && <p className="text-sm text-gray-600 mt-1">({article.date})</p>}
                {article.content && <p className="text-sm mt-1">{article.content}</p>}
              </div>
            </Link>
            <span className="flex items-center ml-auto border-solid border-gray-500 border w-4 h-4 transform rotate-45"></span>
          </li>
        ))}
      </ul>
    </div>
  );
}
